import PropTypes from "prop-types";

const CreativeTemplatePropType = PropTypes.shape({
  displayName: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  previewPath: PropTypes.string.isRequired,
  placements: PropTypes.arrayOf(PropTypes.string).isRequired,
  primaryMimeType: PropTypes.string.isRequired,
  isCreatomateTemplate: PropTypes.bool.isRequired,
  renderedJsonDocument: PropTypes.string
});

export default CreativeTemplatePropType;
